<template>
  <div class="container has-text-centered" style="margin-top: 42px;">
    <h1 class="title">Order was successfully created.</h1>
    <b-button type="is-primary" class="has-text-centered"
              @click="$router.push('/orders')">List of
      orders
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'Success'
}
</script>
